import { render, staticRenderFns } from "./right-third-content.vue?vue&type=template&id=5140097d&scoped=true&"
import script from "./right-third-content.vue?vue&type=script&lang=js&"
export * from "./right-third-content.vue?vue&type=script&lang=js&"
import style0 from "./right-third-content.vue?vue&type=style&index=0&id=5140097d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140097d",
  null
  
)

export default component.exports